// extracted by mini-css-extract-plugin
export default {"header":"EH","light":"FH","dark":"GH","headertitle":"HH","fname":"IH","headerContent":"JH","right":"KH","descriptionwrapper":"LH","appear":"MH","second":"NH","third":"OH","forth":"PH"};
    if(module.hot) {
      // 1726593107800
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  